var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurePrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_115550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 10.8334C4.16675 10.3914 4.34234 9.96746 4.6549 9.6549C4.96746 9.34234 5.39139 9.16675 5.83341 9.16675H14.1667C14.6088 9.16675 15.0327 9.34234 15.3453 9.6549C15.6578 9.96746 15.8334 10.3914 15.8334 10.8334V15.8334C15.8334 16.2754 15.6578 16.6994 15.3453 17.0119C15.0327 17.3245 14.6088 17.5001 14.1667 17.5001H5.83341C5.39139 17.5001 4.96746 17.3245 4.6549 17.0119C4.34234 16.6994 4.16675 16.2754 4.16675 15.8334V10.8334Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 13.3333C9.16675 13.5543 9.25455 13.7663 9.41083 13.9226C9.56711 14.0789 9.77907 14.1667 10.0001 14.1667C10.2211 14.1667 10.4331 14.0789 10.5893 13.9226C10.7456 13.7663 10.8334 13.5543 10.8334 13.3333C10.8334 13.1123 10.7456 12.9004 10.5893 12.7441C10.4331 12.5878 10.2211 12.5 10.0001 12.5C9.77907 12.5 9.56711 12.5878 9.41083 12.7441C9.25455 12.9004 9.16675 13.1123 9.16675 13.3333Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 9.16667V5.83333C6.66675 4.94928 7.01794 4.10143 7.64306 3.47631C8.26818 2.85119 9.11603 2.5 10.0001 2.5C10.8841 2.5 11.732 2.85119 12.3571 3.47631C12.9822 4.10143 13.3334 4.94928 13.3334 5.83333V9.16667",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_115550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePrivate);
export default __webpack_public_path__ + "static/media/SecurePrivate.560973fa1badb1be59d19aefe86639b6.svg";
export { ForwardRef as ReactComponent };